import React from 'react';
import {FormikContext, FormikContextType} from 'formik';
import AppButton from '../app-button';

interface SubmitButtonProps extends React.HTMLProps<HTMLButtonElement> {
  title: string;
  variant?: string;
  customComponent?: any;
  disabled?: boolean;
  onClickFunction?(): void;
}

function AppFormSubmitButton({
  title,
  variant,
  customComponent,
  children,
  disabled = false,
  onClickFunction,
  ...rest
}: SubmitButtonProps) {
  const formik = React.useContext(
    FormikContext as React.Context<FormikContextType<any> | null>
  );
  const handleSubmit = formik?.handleSubmit;

  if (customComponent) {
    return (
      <div
        onClick={() => {
          if (onClickFunction) onClickFunction();
          if (handleSubmit) handleSubmit();
        }}>
        {customComponent}
      </div>
    );
  }

  return (
    <AppButton
      variant={variant}
      onClick={() => {
        if (onClickFunction) onClickFunction();
        if (handleSubmit) handleSubmit();
      }}
      type={handleSubmit ? 'submit' : 'button'}
      disabled={disabled}  // ✅ dev can still override
      {...rest}>
      {children ? children : title}
    </AppButton>
  );
}

export default AppFormSubmitButton;
